///<reference path="../../../../typings/tsd.d.ts" />

module branches {
    
    import api = API.Client; 
   
    export class BranchesService {
        branchesAPI: api.BranchesApi;
        saleTypesAPI: api.SellTypesApi;
        sellersAPI: api.SellersApi;
        
        /*@ngInject*/
        constructor($http: ng.IHttpService) {
            this.branchesAPI = new api.BranchesApi($http);
            this.saleTypesAPI = new api.SellTypesApi($http);
            this.sellersAPI = new api.SellersApi($http);
        };
        
        getBanches(): ng.IPromise<Array<API.Client.Branch>> {
            return this.branchesAPI.branchesGet().then(response => {
                response.data.branches.forEach(b => b.name = `${b.cvcBranchCode} - ${b.name}`);
                return response.data.branches;
            });
        };
        
        getSaleTypes(branchCode: number): ng.IPromise<api.SellTypesRS> {
            return this.saleTypesAPI.sellTypesBranchCodeGet(branchCode).then(response => response.data.SellTypes.SellType);
        };
        
        getSellers(branchCode: number, saleType: number): ng.IPromise<api.SellersRS> {
            return this.sellersAPI.sellerGet(branchCode, saleType, "S").then(response => response.data.sellers);
        };
    }
    
    angular.module('branches', []).service('branchesService', BranchesService);

}
